enum ChromeStatus {
  NOT_READY,
  READY,
  FORCED_READY
}

export { ChromeStatus };
